// Vendor imports
const { createSelector } = require('reselect')

module.exports = {
  createFeedSelectors,
  defaultFeedSelectors: createFeedSelectors('feed')
}

function createFeedSelectors(stateKey) {
  function getStream(state) {
    return state.get(stateKey)
  }

  function getItems(state) {
    return getStream(state).items
  }

  function getMeta(state) {
    return getStream(state).meta
  }

  function getIsNextPageAvailable(state) {
    return getStream(state).isNextPageAvailable
  }

  function getNextPageUrl(state) {
    return getStream(state).nextPageUrl
  }

  // Memoize to prevent unnecessary updates
  // https://github.com/reduxjs/reselect#motivation-for-memoized-selectors
  const getDenormalizedItems = createSelector(
    getStream,
    stream => stream.getDenormalizedItems()
  )

  return {
    getDenormalizedItems,
    getIsNextPageAvailable,
    getItems,
    getMeta,
    getNextPageUrl,
    getStream
  }
}
